<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <div class="dashboard-details">
      <div class="dashboard-logo">
        <img
          src="../../../assets/images/logo-dark.png"
          class="img-logo"
          alt="logo"
          (click)="goToSetting()"
        />
      </div>
    </div>

    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <i
        class="fa-regular fa-circle-down fs-2"
        *ngIf="navbarCollabsed"
        (click)="openNavMobile()"
      ></i>
      <i
        class="fa-regular fa-circle-up fs-2"
        *ngIf="!navbarCollabsed"
        (click)="openNavMobile()"
      ></i>
    </button>

    <div class="nav-buttons">
      <ng-container *ngIf="showSideNav">
        <ng-container *ngTemplateOutlet="showSideNav"></ng-container>
      </ng-container>
    </div>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <div class="user-profile navbar-nav">
        <div class="profile-details">
          <app-language-toggle></app-language-toggle>

          <!-- sidemenuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu -->
          <div class="side-menu-card flex justify-content-center">
            <p-sidebar
              [(visible)]="sidebarVisible"
              [position]="isRtl ? 'right' : 'left'"
              appendTo="body"
              [modal]="true"
              styleClass="notifications-sidebar"
            >
              <div class="side-header">
                <button (click)="sidebarVisible = false">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>

              <div>
                <p-tabView>
                  <p-tabPanel [header]="'notifications' | translate">
                    <div class="notifications">
                      <div class="tap-header">
                        <p>{{ "notifications" | translate }}</p>
                        <a class="dismiss" (click)="markAllAsRead()">
                          {{ "notifcation.DISMISS_ALL" | translate }}</a
                        >
                      </div>
                      <a *ngFor="let notification of notifications">
                        <div class="row notification-content">
                          <div class="d-flex">
                            <div class="col-auto align-self-center">
                              <div class="icon">
                                <i class="fa-solid fa-bell"></i>
                              </div>
                            </div>
                            <div class="col-md-9 p-0">
                              <h6>
                                {{ notification.title }}
                              </h6>
                              <p class="tap-paragraph">
                                {{ notification.description }}
                              </p>
                              <p class="tap-paragraph">
                                {{ notification.message }}
                              </p>
                              <p class="tap-time">
                                {{ notification.createdAt }}
                              </p>
                            </div>
                            <div class="col-md-1 p-0 d-flex align-items-end">
                              <a
                                class="dismiss"
                                (click)="markAsRead(notification.id)"
                              >
                                {{ "notifcation.DISMISS" | translate }}</a
                              >
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </p-tabPanel>
                </p-tabView>
              </div>
            </p-sidebar>
            <button (click)="sidebarVisible = true" class="bell-btn">
              <i class="fa-solid fa-bell"></i>
            </button>
          </div>
          <!-- end sidemenuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu  -->

          <div class="user-panel-card flex justify-center">
            <button
              pButton
              type="button"
              class="p-button p-component flex flex-col items-start"
              (click)="op.toggle($event)"
            >
              <span class="hello">{{ "hello" | translate }}</span>
              <span class="user-name">{{ accoutDto?.name }}</span>
            </button>
            <p-overlayPanel #op>
              <div class="overlayPanel-content">
                <div class="overlayPanel-header">
                  <div class="badge">
                    <img [src]="profileImageUrl" alt="Profile" class="profile-image" (error)="onImageError($event)" />
                  </div>
                  <div class="user-name-card">
                    <span>{{ accoutDto?.email }}</span>
                  </div>
                </div>
                <div class="overlayPanel-body">
                  <a class="setting" (click)="goToSetting()">
                    <div class="tap-name" >
                      <i class="fa fa-cog" aria-hidden="true"></i>
                      <span>{{ "SETTINGS" | translate }}</span>
                    </div>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                  </a>
                  <hr />
                  <div class="logout">
                    <button (click)="logout()">
                      {{ "LOGOUT" | translate }}
                      <i class="fa fa-sign-out" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </p-overlayPanel>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>

<!--


      <div class="user-profile">
        <button mat-button [matMenuTriggerFor]="beforeMenuProfile">
          <div class="profile-details">
            <div class="admin_name">{{ userName }} سشيشسيشسيشس</div>
            <i class="ri-arrow-down-s-line"></i>
          </div>
        </button>
        <mat-menu #beforeMenuProfile="matMenu" xPosition="before">
          <a class="change_pass" href="#" mat-menu-item [routerLink]="['account/change-password']">
            <i class="ri-lock-line"></i>
            <span>Change Password</span>
          </a>
          <a class="log_out" (click)="logOut()" mat-menu-item>
            <i class="ri-logout-circle-r-line"></i>
            <span>Logout</span>
          </a>
        </mat-menu>
      </div> -->
